import { IMPORT_JOB_TERMINAL_STATUSES, type ImportJobStatus } from '@/types/api';

/**
 * Reports whether a Notion sync job has reached a terminal status
 * (`completed` / `failed`). Used by the SSE stream hook to know when to
 * tear the connection down and by the outcome screen to know when the
 * terminal per-row outcome is fetchable.
 *
 * Lives here (not in `@/types/api/IZone.ts`) per the project's "no
 * runtime helpers in types/" rule (`frontend/src/types/CLAUDE.md`).
 */
export function isImportJobTerminal(status: ImportJobStatus): boolean {
  return (IMPORT_JOB_TERMINAL_STATUSES as readonly string[]).includes(status);
}
